<template>
    <div></div>
</template>

<script>
export default {
    name: 'DeleteFactorProduct',
    props: {
        popupDeleteFactor: {
            type: Boolean,
            default: false,
        },
        factorId: Number
    },

    watch: { 
      	popupDeleteFactor: function(newVal) {
            if(newVal == true){
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: "حذف فاکتور",
                    text: `فاکتور حذف شود؟`,
                    acceptText: "حذف",
                    cancelText: "انصراف",
                    accept: this.deleteFactor,
                    cancel: this.cancelDelete,
                })
            }            
        },
    },
    
    methods: {
        cancelDelete(){
            this.$emit('updatePopupDeleteFactor', false)
        },

        deleteFactor(){
            this.$vs.loading()
            this.$emit('updatePopupDeleteFactor', false)
			this.$store.dispatch('deleteFactor', this.factorId)
			.then(() => {
                this.$vs.loading.close()
				this.$vs.notify({
					title: '',
					text: 'محصول با موفقیت حذف شد.',
					iconPack: 'feather',
					icon: 'icon-check-square',
					color: 'success'
				})
			})
			.catch(() => {
                this.$vs.loading.close()
				this.$vs.notify({
				title: '',
				text: 'خطا در اتصال به اینترنت',
				iconPack: 'feather',
				icon: 'icon-alert-circle',
				color: 'warning'
				})
			})
		},
    }
}
</script>